import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

const ImageFileAttach = forwardRef((props, ref) => {
    const [showImages, setShowImages] = useState([]);
    const [imageFiles, setImageFiles] = useState([]);
    const [countImages, setCountImages] = useState(0);

    useImperativeHandle(ref, () => ({
        getImages: () => imageFiles
    }));

    const handleAddImages = (event) => {
        const files = Array.from(event.target.files);
        let newImageFiles = [...imageFiles];
        let newShowImages = [...showImages];

        for (let i = 0; i < files.length; i++) {
            newShowImages.push(URL.createObjectURL(files[i]));
            newImageFiles.push(files[i]);
        }

        if (newImageFiles.length > 10) {
            alert('10개 까지만 올릴 수 있습니다.');
            newImageFiles = newImageFiles.slice(0, 10);
            newShowImages = newShowImages.slice(0, 10);
        }

        setShowImages(newShowImages);
        setImageFiles(newImageFiles);
        setCountImages(newImageFiles.length);
    };

    const handleDeleteImage = (id) => {
        URL.revokeObjectURL(showImages[id]);
        setShowImages(showImages.filter((_, index) => index !== id));
        setImageFiles(imageFiles.filter((_, index) => index !== id));
        setCountImages(imageFiles.length - 1);
    };

    return (
        <div className='image-file-attach-box'>
            <div className='img-attach-btn-box'>
                <label htmlFor="input-file" />
                <input
                    type="file"
                    id="input-file"
                    accept="image/*"
                    multiple
                    onChange={handleAddImages}
                    style={{ display: 'none' }}
                />
                <span>{countImages}/10</span>
            </div>

            <div className='img-attach-view-box scroll-hidden'>
                {showImages.map((image, id) => (
                    <div className="imageContainer" key={id}>
                        <img src={image} alt={`${image}-${id}`} />
                        <button onClick={() => handleDeleteImage(id)} className='img-attach-del-btn'>
                            <span className='blind'>삭제</span>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
});

export default ImageFileAttach;